/*
 * Public API Surface of shared-services
 */

// Core - Guards
export * from './lib/core/guards/auth.guard';

// Core - Helpers
export * from './lib/core/helpers/clipboard-helpers';

// Core - Interceptors
export * from './lib/core/interceptors/auth.interceptor';

// Core - Services
export * from './lib/core/services/api-config.service';
export * from './lib/core/services/event-bus.service';
export * from './lib/core/services/keycloak-auth.service';

// Core - Utils
export * from './lib/core/utils/auth-check';

// Models
export * from './lib/models/flow-diagram.types';
export * from './lib/models/paged.types';
export * from './lib/models/json-schema.types';

// Environments
export * from './lib/environments/environment';

// Services
export * from './lib/services/agent-configuration.service';
export * from './lib/services/authentication.service';
export * from './lib/services/beta-feature.service';
export * from './lib/services/category.service';
export * from './lib/services/events.service';
export * from './lib/services/flow-activity.service';
export * from './lib/services/flow-step-execution.service';
export * from './lib/services/flow-system.service';
export * from './lib/services/flow.execution.service';

// flow.instance re-exports (LogItem & FlowExecutionStatus already exported from flow.execution)
export {
  FlowService,
  type FlowInstance,
  type FlowInstanceSummary,
  type ExecutedStep,
  type ExecutedStepMetaData,
  type ScheduledStep,
  type InstanceData,
  type CallbackConfiguration,
  type FlowExecutionContext,
  FlowExecutionStatus as FlowInstanceExecutionStatus,
  type LogItem as FlowInstanceLogItem,
  type FlowAuditTrailEntry,
  type FlowAuditTrailEvent,
} from './lib/services/flow.instance.service';

// flowblueprint re-exports (FlowStep already exported from flow-system with a different shape)
export {
  FlowblueprintService,
  type Flowblueprint,
  type ExecutionSettings,
  type FlowStep as FlowblueprintStep,
} from './lib/services/flowblueprint.service';

export * from './lib/services/integrated-flow.service';

// integration re-exports (FlowExecutionLog already exported from flow.execution with a different shape)
export {
  IntegrationService,
  type Integration,
  type NewIntegrationResponse,
  type ExternalAuthentication,
  type FlowExecutionLog as IntegrationFlowExecutionLog,
  FlowExecutionState,
} from './lib/services/integration.service';

export * from './lib/services/secret.service';
export * from './lib/services/tenant.service';
export * from './lib/services/test-case.service';

// test-group re-exports (TestRunData already exported from test-case)
export {
  TestGroupService,
  type TestGroup,
  type TestConfiguration,
} from './lib/services/test-group.service';

export * from './lib/services/test-result.service';
export * from './lib/services/tools.service';
export * from './lib/services/user.service';
export {
  ServiceAccountService,
  type ServiceAccount,
} from './lib/services/service-account.service';
export * from './lib/services/permission.service';
export * from './lib/services/permissionSet.service';
export * from './lib/services/webhook.service';
export * from './lib/services/storage.service';
export * from './lib/services/feedback.service';
export * from './lib/services/teams-integration.service';
